var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramStankey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.234 160L346.635 256H592C600.836 256 608 263.164 608 272V304C608 312.836 600.836 320 592 320H276.771L315.172 384H576C593.674 384 608 398.326 608 416V448C608 465.674 593.674 480 576 480H297.064C274.584 480 253.752 468.205 242.186 448.928L164.828 320H64C46.326 320 32 305.674 32 288V224C32 206.326 46.326 192 64 192H235.766L313.123 63.072C324.689 43.795 345.521 32 368.002 32H576C593.674 32 608 46.326 608 64V128C608 145.674 593.674 160 576 160H404.234Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramStankey);
export default __webpack_public_path__ + "static/media/diagram-stankey.9b2e1a1aa2a45117edf82cd2b70072b8.svg";
export { ForwardRef as ReactComponent };